// Add this utility function in src/util/analytics.js
import app from "./firebase";
import firebase from "firebase/compat/app";

const trackDownload = async (userData, flyerChoice, isCobranded = false) => {
  try {
    // get isadmin from the local storage
    console.log("admin:", userData);

    // filter user out that are admin
    if (userData.email === "jbrubaker@onetrusthomeloans.com") {
      return;
    }

    // Build the document data, excluding undefined fields
    const docData = {
      isCobranded: isCobranded,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      brandSelected: userData.brand?.name || "No Brand Selected",
      action: "download",
      isAdmin: userData.admin || false,
    };

    // Only add fields if they have valid values
    if (userData.email || userData.userData?.Email) {
      docData.userEmail = userData.email || userData.userData?.Email;
    }

    if (
      docData.userEmail === "jbrubaker@onetrusthomeloans.com" ||
      docData.userEmail === "cvelez@onetrusthomeloans.com" ||
      docData.userEmail === "rpirio@onetrusthomeloans.com" ||
      docData.userEmail === "mrodriguez@onetrusthomeloans.com"
    ) {
      return;
    }

    if (userData.id || userData.userData?.UserId) {
      docData.userId = userData.id || userData.userData?.UserId;
    }

    if (userData.brand?.id) {
      docData.brandId = userData.brand.id;
    }

    if (flyerChoice.id) {
      docData.flyerId = flyerChoice.id;
    }

    if (flyerChoice.name) {
      docData.flyerName = flyerChoice.name;
    }

    await app.firestore().collection("analytics").add(docData);
  } catch (error) {
    console.error("Error tracking download:", error);
  }
};

const trackLogin = async (userData) => {
  try {
    console.log("Tracking login for:", userData);

    if (userData.admin) {
      return;
    }

    // Build the document data, excluding undefined fields
    const docData = {
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      action: "login",
    };

    // Only add fields if they have valid values
    if (userData.email || userData.userData?.Email) {
      docData.userEmail = userData.email || userData.userData?.Email;
    }

    if (
      docData.userEmail === "jbrubaker@onetrusthomeloans.com" ||
      docData.userEmail === "cvelez@onetrusthomeloans.com" ||
      docData.userEmail === "rpirio@onetrusthomeloans.com" ||
      docData.userEmail === "mrodriguez@onetrusthomeloans.com"
    ) {
      return;
    }

    if (userData.id || userData.userData?.UserId) {
      docData.userId = userData.id || userData.userData?.UserId;
    }

    if (userData.brand?.id) {
      docData.brandId = userData.brand.id;
    }

    await app.firestore().collection("analytics").add(docData);
  } catch (error) {
    console.error("Error tracking login:", error);
  }
};

export { trackDownload, trackLogin };
